import React, { useEffect, useState } from 'react'
import Configurator from '../configurator'
import FormDescription from '../components/shared/wysiwyg/form-description'
import { database } from '../components/shared/database'
import { generateUUID } from '../components/shared/uuid-generator'
import QrScanner from '../components/shared/qr-scanner'
import classNames from 'classnames'
import { Link, Redirect } from 'react-router-dom'

const FoodForm = ({
    food,
}) => {
    const configurator = new Configurator()

    const [uidFood, setUidFood] = useState(null)
    const [ean, setEan] = useState('')
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [scanning, setScanning] = useState(false)
    const [uidFridge, setUidFridge] = useState(null)
    const [readerType, setReaderType] = useState('ean_reader')
    const [redirect, setRedirect] = useState(null)

    useEffect(() => {
        if (food?.uidFood) {
            setUidFood(food?.uidFood)
            setEan(food?.ean || '')
            setName(food?.name || '')
            setDescription(food?.description || '')
        }
    }, [food])

    const toggleScan = (readerType) => {
        setScanning(!scanning)
        setReaderType(readerType)
    }

    const onScanDetected = result => {
        setScannedEan(result)
        toggleScan()
    }


    const setScannedEan = ean => {
        database('food')
            .where('ean', '==', ean)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                    const snapData = doc.data()

                    setName(snapData.name)
                    setDescription(snapData.description)
                    setUidFood(snapData.uid)
                })
            })

        setEan(ean)
    }

    const saveForm = async event => {
        event.preventDefault()

        const uidFoodStore = uidFood || generateUUID()
        const uidFridgeStore = uidFridge || generateUUID()

        await database('food')
            .doc(uidFoodStore)
            .set({
                uid: uidFoodStore,
                ean: ean,
                name: name,
                description: description,
            })

        await database('fridge')
            .doc(uidFridgeStore)
            .set({
                uid: uidFridgeStore,
                uidFood: uidFoodStore,
                name: name,
                description: description,
            })

        setUidFood(null)
        setEan('')
        setName('')
        setDescription('')
        setScanning(false)
        setUidFridge(null)
        setReaderType('ean_reader')

        setRedirect(`/add/${uidFridgeStore}`)
    }

    return (
        <div className="p-3">
            {redirect && <Redirect to={redirect} />}
            <form onSubmit={saveForm} className="position-relative">
                {scanning && <QrScanner onDetected={onScanDetected} readerType={readerType} />}
                <div className="mb-3">
                    <label htmlFor="form-ean" className="form-label d-flex flex-row align-items-center">
                        <div>
                            EAN
                        </div>

                        <div
                            onClick={() => toggleScan('ean_reader')}
                            className={classNames({
                                'btn btn-sm ml-3': true,
                                'btn-outline-success': !scanning,
                                'btn-outline-warning': scanning,
                            })}
                        >
                            {!scanning && 'Naskenovat dlouhý EAN'}
                            {scanning && 'Stop skenování'}
                        </div>
                        <div
                            onClick={() => toggleScan('ean_8_reader')}
                            className={classNames({
                                'btn btn-sm ml-3': true,
                                'btn-outline-success': !scanning,
                                'btn-outline-warning': scanning,
                            })}
                        >
                            {!scanning && 'Naskenovat krátký EAN'}
                            {scanning && 'Stop skenování'}
                        </div>
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        id="form-ean"
                        value={ean}
                        autoComplete="off"
                        onChange={event => setScannedEan(event.target.value)}
                    />
                </div>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="mb-3">
                            <label htmlFor="form-name" className="form-label">
                                Název
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="form-name"
                                value={name}
                                autoComplete="off"
                                onChange={event => setName(event.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="form-name" className="form-label">
                                Popis
                            </label>
                            <textarea
                                onChange={event => setDescription(event.target.value)}
                                className="form-control"
                                rows="6"
                                value={description}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ position: 'relative', bottom: 0, width: '100%', left: 0 }}>
                    <Link to="/" className="btn btn-outline-warning col-6">Neukládat nic</Link>
                    <button type="submit" className="btn btn-primary col-6">Uložit a zadat datum</button>
                </div>
            </form>
        </div>
    )
}

export default FoodForm
